

module.exports = __webpack_require__.stylable.create(
    "EventListItem2064615590",
    {"classes":{"root":"EventListItem2064615590__root","content":"EventListItem2064615590__content","eventType":"EventListItem2064615590__eventType","eventLocation":"EventListItem2064615590__eventLocation","condensedTitle":"EventListItem2064615590__condensedTitle","condensedTitleStrong":"EventListItem2064615590__condensedTitleStrong","condensedTitleEvent":"EventListItem2064615590__condensedTitleEvent","eventDateTime":"EventListItem2064615590__eventDateTime"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    4,
    "EventListItem2064615590",
    null
);
